export default __webpack_public_path__ + "static/media/team44.ae77a992.JPG";